
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/at-home-mining",
      function () {
        return require("private-next-pages/at-home-mining.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/at-home-mining"])
      });
    }
  